module.exports = __webpack_public_path__ + "files/4506ff8930ce62488c2ba9e5126d49e3.png";